import $ from "jquery";

function insertMainStyle(css, varName) {
  var style = document.createElement("style");
  style.textContent = css.replace(/##value##/ig, `var(${varName})`);
  $(document.head).append(style);
}

function storageKey(opts) {
  return "css_tweakers_" + encodeURIComponent(opts.css.replace(/\s+/g, ""));
}

function fromLocalStorage(opts) {
  if(opts.persistence !== "local") return null;
  const key = storageKey(opts);
  const value = localStorage.getItem(key);
  return value === undefined ? null : parseFloat(value);
}

function toLocalStorage(opts, val) {
  if(opts.persistence !== "local") return;
  const key = storageKey(opts);
  if(val !== null) localStorage.setItem(key, val);
  else localStorage.removeItem(key);
}

const tweakers = [];
let id = 1;

function initCSSSlider(opts) {
  const required = ["input", "css", "value"];
  for (const optName of required) {
    if(!opts.hasOwnProperty(optName)) {
      console.error(`initCSSSlider needs '${optName}' parameter`);
      return;
    }
  }

  var $input = $(opts.input);
  var unit = opts.unit || "";

  var varName = `--css-tweaker-var-${id++}`;
  insertMainStyle(opts.css, varName);

  const defaultVal = parseFloat(opts.value);
  const initVal = fromLocalStorage(opts) || defaultVal;

  function set(val) {
    document.body.style.setProperty(varName, val+unit);
  }

  var slider = $input.ionRangeSlider({
    from: initVal,
    min: parseInt($input.attr("min")),
    max: parseInt($input.attr("max")),
    grid: true,
    onChange: function(data) {
      const val = data.from;
      set(val);
      toLocalStorage(opts, val);
    }
  }).data("ionRangeSlider");

  set(initVal);

  tweakers.push({
    reset() {
      slider.update({ from: defaultVal });
      set(defaultVal);
      toLocalStorage(opts, null);
    }
  });
}

export const CSSTweakers = {
  resetAll() {
    tweakers.forEach(t => t.reset());
  },

  slider: initCSSSlider
};

